import React__default from 'react';
import classNames from 'classnames';
import spacingTokens from '../../../spacing/tokens.module.css.js';
import styles from './Stack.module.css.js';

/**
 *
 * The `Stack` component uses spacing tokens to set the spacing between its child elements. The following spacing tokens are available:
 *
 * > ** spacing-none ** = 0px
 *
 * > ** spacing-xxs ** = 4px
 *
 * > ** spacing-xs ** = 8px
 *
 * > ** spacing-sm ** = 12px
 *
 * > ** spacing-md ** = 16px
 *
 * > ** spacing-lg ** = 24px
 *
 * > ** spacing-xl ** = 32px
 *
 * > ** spacing-xxl ** = 40px
 *
 *
 * #### Developer guidelines:
 *
 * - Use the `space` prop to specify the spacing between the child elements, using one of the spacing tokens listed above.
 * - The Stack component should only be used to space its immediate child elements, and not to apply global layout styles to the entire page.
 *
 */
var Stack = function (_a) {
    var _b = _a.as, as = _b === void 0 ? 'div' : _b, _c = _a.space, space = _c === void 0 ? 'spacing-none' : _c, children = _a.children, className = _a.className;
    var Element = as;
    return (React__default.createElement(Element, { className: classNames(styles.root, className), style: {
            '--Space': spacingTokens[space] || '4px',
        } }, children));
};

export { Stack };
//# sourceMappingURL=Stack.js.map
